<div class="loading-overlay">
  <div
    class="loading-content"
    [class.loading-content--with-progress]="showProgressBar || subMessage"
  >
    <div class="loading-content__header">
      <i class="ri-loader-4-line spin"></i>
      <span class="loading-content__message">{{ message | translate : messageParams }}</span>
    </div>
    <p *ngIf="subMessage" class="loading-content__sub">
      {{ subMessage | translate : subMessageParams }}
    </p>
    <mat-progress-bar
      *ngIf="showProgressBar"
      [mode]="progressMode"
      [value]="progress"
    ></mat-progress-bar>
  </div>
</div>
